// extracted by mini-css-extract-plugin
export default {"user-points__icon":"userPoints_user-points__icon__65ga3","user-points__points":"userPoints_user-points__points__pKVYn"};